// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._12l2u2gc{margin-inline-end:var(--ds-space-100,8px)}\n._1e0c1txw{display:flex}\n._1wyb1cby{font-size:1.125rem}\n._4cvr1h6o{align-items:center}\n._vwz4cjiy{line-height:1.2}", ""]);
// Exports
module.exports = exports;
